import { renderPrice } from '../../../../services/renderPrice';

export const formatPrice = (price: number) => {
    if (isNaN(price)) {
        return '';
    }
    return renderPrice(price);
};
